// ==============================|| THEME CONSTANT  ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const LAYOUT_CONST = {
  VERTICAL_LAYOUT: 'vertical',
  HORIZONTAL_LAYOUT: 'horizontal'
};

export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 270;

// ==============================|| THEME CONFIG  ||============================== //

const config = {
  fontFamily: `'Urbanist', sans-serif`,
  menuOrientation: 'vertical',
  container: false,
  mode: 'light',
  presetColor: 'default',
  themeDirection: 'ltr',
  breadcrumbs: null
};

export default config;

export const LIST_API_LIMIT = 500;

// Environment configs start
export const ENV = { DEV: 'dev', STAGING: 'staging', UAT: 'uat', PROD: 'prod', DEFAULT: 'dev' }; // DEFAULT specifies the fallback environment for localhost

export const envUrls = {
  [ENV.DEV]: ['dev.clearsourcejobs.com'],
  [ENV.STAGING]: ['staging.clearsourcejobs.com'],
  [ENV.UAT]: ['uat.clearsourcejobs.com'],
  [ENV.PROD]: ['app.clearsourcejobs.com', 'd3tmjxhnf3ab8w.cloudfront.net', 'cs-ats-website-prod.s3-website-us-east-1.amazonaws.com']
};

// Determines the current environment based on hostname
const getCurrentEnv = () => {
  const hostname = window.location.hostname;

  if (envUrls[ENV.DEV].includes(hostname)) return ENV.DEV;
  else if (envUrls[ENV.STAGING].includes(hostname)) return ENV.STAGING;
  else if (envUrls[ENV.UAT].includes(hostname)) return ENV.UAT;
  else if (envUrls[ENV.PROD].includes(hostname)) return ENV.PROD;
  else return ENV.DEFAULT;
};

// Environment-specific configuration
const devEnvConfig = {
  s3UploadsBucket: 'cs-ats-uploads-dev',
  apiBaseUrl: 'https://zxtnfylus2.execute-api.us-east-1.amazonaws.com/dev',
  streamLambdaUrl: 'https://g5kca42sqxssfzg6amhil5jouy0syvrj.lambda-url.us-east-1.on.aws'
};

const stagingEnvConfig = {
  s3UploadsBucket: 'cs-ats-uploads-staging',
  apiBaseUrl: 'https://pcqtco666m.execute-api.us-east-1.amazonaws.com/staging',
  streamLambdaUrl: 'https://rcwbnxa4w6m2dr2dztfhpbnnqm0andbk.lambda-url.us-east-1.on.aws'
};

const uatEnvConfig = {
  s3UploadsBucket: 'cs-ats-uploads-uat',
  apiBaseUrl: 'https://4l04iqq7l8.execute-api.us-east-1.amazonaws.com/uat',
  streamLambdaUrl: 'https://2g5672fbnuhrvytiejdau2hyve0cbpte.lambda-url.us-east-1.on.aws'
};

const prodEnvConfig = {
  s3UploadsBucket: 'cs-ats-uploads-prod',
  apiBaseUrl: 'https://9e3oxdka9d.execute-api.us-east-1.amazonaws.com/prod',
  streamLambdaUrl: 'https://sxuawfm6ta7gr5c3br6sqwxviu0sryac.lambda-url.us-east-1.on.aws'
};

const envConfigs = {
  [ENV.DEV]: { ...devEnvConfig, name: ENV.DEV },
  [ENV.STAGING]: { ...stagingEnvConfig, name: ENV.STAGING },
  [ENV.UAT]: { ...uatEnvConfig, name: ENV.UAT },
  [ENV.PROD]: { ...prodEnvConfig, name: ENV.PROD }
};

export const envConfig = envConfigs[getCurrentEnv()];
// Environment configs end
